import * as Yup from "yup";

export const LoginSchema = {
	initialValues: { username: "", password: "" },
	validation: Yup.object({
		username: Yup.string().required("Username is required!"),
		password: Yup.string().required("Password is required!"),
	}),
};

export const CreateUserSchema = {
	initialValues: { username: "", email: "", password: "", cpassword: "" },
	validation: Yup.object({
		username: Yup.string().required("Username is required!"),
		email: Yup.string()
			.email("Invalid email address!")
			.required("Email address is required!"),
		password: Yup.string()
			.min(8, "Password must contain at least 8 characters")
			.matches(
				/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]/,
				"Password must contain at least 1 uppercase, lowercase character and number"
			)
			.required("Password is required!"),
		cpassword: Yup.string()
			.oneOf([Yup.ref("password"), null], "Password does not match!")
			.required("Confirm Password is required!"),
	}),
};

export const ChangePasswordSchema = {
	initialValues: { opassword: "", npassword: "", cpassword: "" },
	validation: Yup.object({
		opassword: Yup.string().required("Old Password is required!"),
		npassword: Yup.string()
			.min(8, "New Password must contain at least 8 characters")
			.matches(
				/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]/,
				"New Password must contain at least 1 uppercase, lowercase character and number"
			)
			.required("Password is required!"),
		cpassword: Yup.string()
			.oneOf([Yup.ref("npassword"), null], "Password does not match!")
			.required("Confirm Password is required!"),
	}),
};

export const ResetPasswordSchema = {
	initialValues: { npassword: "", rpassword: "" },
	validation: Yup.object({
		npassword: Yup.string()
			.min(8, "New Password must contain at least 8 characters")
			.matches(
				/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]/,
				"New Password must contain at least 1 uppercase, lowercase character and number"
			)
			.required("Password is required!"),
		rpassword: Yup.string()
			.oneOf([Yup.ref("npassword"), null], "Password does not match!")
			.required("Confirm Password is required!"),
	}),
};

export const NewMerchantSchema = {
	validation: Yup.object({
		name: Yup.string().required("Name is required"),
		mid: Yup.string().required("MID is required"),
	}),
};

export const EditMerchantSchema = {
	validation: Yup.object({
		name: Yup.string().required("Name is required"),
		receiptName: Yup.string(),
		statementName: Yup.string(),
		stripeTerminalLocation: Yup.string(),
	}),
};

export const CustomSolutionSchema = {
	initialValues: {
		name: "",
		adminPin: "",
		callbackUrl: "",
		isHeadless: false,
		isCardOnly: false,
	},
	validation: Yup.object({
		name: Yup.string().required("Name is required!"),
		adminPin: Yup.string()
			.required("Admin PIN is required")
			.matches(
				/^[0-9]{6}$/g,
				"PIN can only contain number and must be 6 digit"
			),
		callbackUrl: Yup.string().url(),
	}),
};

export const CreateResellerSchema = {
	initialValues: { name: "" },
	validation: Yup.object({
		name: Yup.string().required("Name is required!"),
	}),
};
